module.exports = __webpack_public_path__ + "static/media/fly0093.b967e1d3.webp";